// Phone normalization — shared helper used before sending a WhatsApp ticket.
//
// Turns a raw stored number into a clean 10-digit Indian mobile:
//   - drops spaces, dashes, parentheses, dots and a leading '+'
//   - strips an Indian country code ('91' / '+91') or trunk '0' prefix, but
//     ONLY when the length shows it's actually a prefix — so a genuine 10-digit
//     mobile that happens to start with "91" (e.g. 9112345678) is preserved.
//   - the result must be a plausible Indian mobile: 10 digits starting 6–9.
//
// Returns { valid: true, number } or { valid: false, reason } — callers must
// NOT send when valid is false.

export function normalizeIndianMobile(raw) {
  if (raw == null || String(raw).trim() === '') {
    return { valid: false, reason: 'No phone number on file.' };
  }

  // Keep digits only — this drops spaces, dashes, parentheses, dots and '+'.
  let s = String(raw).replace(/\D/g, '');

  // Length-aware prefix stripping (order: longest specific case first).
  if (s.length === 13 && s.startsWith('091')) s = s.slice(3); // 0 + 91 + 10
  else if (s.length === 12 && s.startsWith('91')) s = s.slice(2); // 91 + 10
  else if (s.length === 11 && s.startsWith('0')) s = s.slice(1);  // 0 + 10

  if (/^[6-9]\d{9}$/.test(s)) {
    return { valid: true, number: s };
  }
  return {
    valid: false,
    reason: `"${String(raw).trim()}" is not a valid 10-digit mobile number.`,
  };
}
